import React, { useCallback } from 'react'
import {
	KeypadBackspaceIcon, KeypadDigitDeleteKey, KeypadDigitGrid, KeypadDigitKey, KeypadZeroKey,
} from './index.styled'

const DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']

type Props = {
	onInput: (digit: string) => void
	onDelete: () => void
	deleteLabel: string
}

const RoomChargeKeypad = React.memo(({ onInput, onDelete, deleteLabel }: Props) => {
	const handleZero = useCallback(() => onInput('0'), [onInput])

	const handleDigit = useCallback((digit: string) => () => onInput(digit), [onInput])

	return (
		<KeypadDigitGrid>
			{DIGITS.map(digit => (
				<KeypadDigitKey key={digit} type="button" onClick={handleDigit(digit)}>{digit}</KeypadDigitKey>
			))}
			<KeypadZeroKey type="button" onClick={handleZero}>0</KeypadZeroKey>
			<KeypadDigitDeleteKey type="button" onClick={onDelete} aria-label={deleteLabel}>
				<KeypadBackspaceIcon icon="backspace" />
			</KeypadDigitDeleteKey>
		</KeypadDigitGrid>
	)
})

RoomChargeKeypad.displayName = 'RoomChargeKeypad'
export default RoomChargeKeypad
